import { HeartRateAlertLabel } from "@/entities/heart_rate_alert_setting";

export function translateLevelTitle(label: HeartRateAlertLabel): string {
  switch (label) {
    case "low":
      return "警告";

    case "medium":
      return "注意";

    case "high":
      return "危険";

    case "critical":
      return "超危険";

    default:
      return "-";
  }
}
